(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hholove-creator-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hho-creator-reviews')) {
    customElements.define('hho-creator-reviews', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.abort || !this.isConnected) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.tabs = Array.from(this.querySelectorAll('[data-category]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.dialog = this.querySelector('dialog');
        this.mount = this.querySelector('[data-player-mount]');
        if (!this.tabs.length || !this.dialog) return;
        this.querySelector('[data-tabs]').setAttribute('role', 'tablist');
        this.tabs.forEach((tab) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.hash.slice(1));
        });
        this.panels.forEach((panel) => {
          panel.setAttribute('role', 'tabpanel');
          panel.tabIndex = 0;
          const gallery = panel.querySelector('[data-gallery]');
          gallery.toggleAttribute('data-single', gallery.children.length === 1);
          gallery.addEventListener('scroll', () => this.scheduleControls(), { signal, passive: true });
        });
        this.setAttribute('data-enhanced', '');
        this.activate(this.dataset.initialCategory);
        this.addEventListener('click', (event) => this.handleClick(event), { signal });
        this.querySelector('[data-tabs]').addEventListener('keydown', (event) => this.handleTabKey(event), { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const category = this.tabs.find((item) => item.dataset.blockId === event.detail.blockId);
          if (category) {
            this.activate(category.dataset.category);
            return;
          }
          const card = Array.from(this.querySelectorAll('[data-card]')).find((item) => item.dataset.blockId === event.detail.blockId);
          if (!card) return;
          this.activate(card.closest('[data-panel]').dataset.panel);
          this.scrollToPosition(this.cardPosition(card), 'instant');
        }, { signal });
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeVideo();
        }, { signal });
        this.dialog.addEventListener('close', () => {
          if (!this.dialog.open) this.finishClose();
        }, { signal });
        this.dialog.addEventListener('pointerdown', (event) => {
          this.backdropDown = this.isBackdrop(event);
        }, { signal });
        this.dialog.addEventListener('click', (event) => {
          if (this.backdropDown && this.isBackdrop(event)) this.closeVideo();
          this.backdropDown = false;
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.scheduleControls());
        this.resizeObserver.observe(this);
        this.panels.forEach((panel) => this.resizeObserver.observe(panel.querySelector('[data-gallery]')));
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.controlsFrame);
        this.closeVideo(false);
        this.abort?.abort();
        this.abort = null;
        this.resizeObserver?.disconnect();
      }

      activate(category) {
        const selected = this.panels.find((panel) => panel.dataset.panel === category);
        if (!selected) return;
        this.closeVideo(false);
        this.tabs.forEach((tab) => {
          const active = tab.dataset.category === category;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel) => { panel.hidden = panel !== selected; });
        this.panel = selected;
        this.gallery = selected.querySelector('[data-gallery]');
        this.rtl = getComputedStyle(this.gallery).direction === 'rtl';
        this.gallery.scrollTo({ left: 0, behavior: 'instant' });
        this.updateControls();
      }

      handleTabKey(event) {
        const tab = event.target.closest('[data-category]');
        if (!tab) return;
        const index = this.tabs.indexOf(tab);
        const right = getComputedStyle(tab).direction === 'rtl' ? -1 : 1;
        let next;
        if (event.key === 'ArrowRight') next = index + right;
        if (event.key === 'ArrowLeft') next = index - right;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        const target = this.tabs[(next + this.tabs.length) % this.tabs.length];
        this.activate(target.dataset.category);
        target.focus({ preventScroll: true });
        target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      }

      handleClick(event) {
        const category = event.target.closest('[data-category]');
        if (category) {
          event.preventDefault();
          this.activate(category.dataset.category);
          return;
        }
        const play = event.target.closest('[data-play]');
        if (play) {
          event.preventDefault();
          this.openVideo(play);
        }
        if (event.target.closest('[data-close]')) this.closeVideo();
        const page = event.target.closest('[data-page]');
        if (page) this.scrollToPosition(this.positions[Number(page.dataset.page)]);
        if (event.target.closest('[data-previous]')) this.scrollToPosition(this.positions[Math.max(0, this.currentPage - 1)]);
        if (event.target.closest('[data-next]')) this.scrollToPosition(this.positions[Math.min(this.positions.length - 1, this.currentPage + 1)]);
      }

      cardPosition(card) {
        const viewport = this.gallery.getBoundingClientRect();
        const rect = card.getBoundingClientRect();
        const offset = this.rtl ? viewport.right - rect.right : rect.left - viewport.left;
        return offset + Math.abs(this.gallery.scrollLeft);
      }

      scrollToPosition(position, behavior) {
        if (!Number.isFinite(position)) return;
        this.gallery.scrollTo({
          left: this.rtl ? -position : position,
          behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth')
        });
      }

      scheduleControls() {
        cancelAnimationFrame(this.controlsFrame);
        this.controlsFrame = requestAnimationFrame(() => this.updateControls());
      }

      updateControls() {
        if (!this.gallery || this.panel.hidden) return;
        const max = Math.max(0, this.gallery.scrollWidth - this.gallery.clientWidth);
        const controls = this.panel.querySelector('[data-controls]');
        controls.hidden = max < 2;
        const positions = [];
        Array.from(this.gallery.children).forEach((card) => {
          const position = Math.max(0, Math.min(max, this.cardPosition(card)));
          if (!positions.length || position - positions[positions.length - 1] > 2) positions.push(position);
        });
        this.positions = positions;
        const dots = this.panel.querySelector('[data-dots]');
        if (dots.children.length !== positions.length) {
          const buttons = positions.map((position, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'hho-creators__dot';
            button.dataset.page = index;
            button.setAttribute('aria-label', this.dataset.pageLabel.replace('__NUMBER__', String(index + 1)));
            return button;
          });
          dots.replaceChildren(...buttons);
        }
        const current = Math.abs(this.gallery.scrollLeft);
        this.currentPage = positions.reduce((closest, position, index) => (
          Math.abs(position - current) < Math.abs(positions[closest] - current) ? index : closest
        ), 0);
        Array.from(dots.children).forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.currentPage)));
        this.panel.querySelector('[data-previous]').disabled = this.currentPage === 0;
        this.panel.querySelector('[data-next]').disabled = this.currentPage >= positions.length - 1;
      }

      openVideo(trigger) {
        const template = trigger.closest('[data-card]').querySelector('[data-player-template]');
        if (!template) return;
        document.querySelectorAll('hho-creator-reviews').forEach((component) => {
          if (component !== this) component.closeVideo?.(false);
        });
        this.closeVideo(false);
        this.lastTrigger = trigger;
        this.querySelector('[data-player-title]').textContent = trigger.getAttribute('aria-label');
        this.mount.replaceChildren(template.content.cloneNode(true));
        this.savedOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;
        this.dialog.showModal();
        this.querySelector('[data-close]').focus({ preventScroll: true });
        this.mount.querySelector('video')?.play().catch(() => {});
      }

      isBackdrop(event) {
        if (event.target !== this.dialog) return false;
        const rect = this.dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      }

      closeVideo(restoreFocus = true) {
        if (!this.dialog) return;
        if (this.dialog.open) this.dialog.close();
        this.finishClose(restoreFocus);
      }

      finishClose(restoreFocus = true) {
        this.mount?.querySelectorAll('video').forEach((video) => video.pause());
        this.mount?.replaceChildren();
        if (this.scrollLocked) {
          document.documentElement.style.overflow = this.savedOverflow;
          this.scrollLocked = false;
        }
        if (restoreFocus && this.lastTrigger?.isConnected) this.lastTrigger.focus({ preventScroll: true });
        this.lastTrigger = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hholove-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hho-customer-reviews')) {
    customElements.define('hho-customer-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal:this.abort.signal };
        const previewStats = this.querySelector('template[data-preview-statistics]');
        if (previewStats && (['unpublished','development'].includes(window.Shopify?.theme?.role))) {
          previewStats.replaceWith(previewStats.content.cloneNode(true));
        }
        this.rail = this.querySelector('[data-rail]');
        this.group = this.querySelector('[data-group]');
        this.toggle = this.querySelector('[data-toggle]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = matchMedia('(min-width: 0px)');
        this.paused = this.dataset.autoplay !== 'true' || Boolean(window.Shopify?.designMode);
        this.hovered = false;
        this.inView = false;
        this.position = this.rail.scrollLeft;
        if (this.group.children.length > 1) {
          this.clone = this.group.cloneNode(true);
          this.clone.removeAttribute('data-group');
          this.clone.setAttribute('data-clone', '');
          this.clone.setAttribute('aria-hidden', 'true');
          this.clone.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
          this.clone.querySelectorAll('a,summary,button').forEach(el => el.setAttribute('tabindex', '-1'));
          this.clone.addEventListener('pointerdown', event => event.preventDefault(), options);
          this.clone.addEventListener('click', event => {
            const action = event.target.closest('a,summary,button');
            if (!action) return;
            event.preventDefault();
            const clonedCard = action.closest('.hho-customers__card');
            const cardIndex = [...this.clone.children].indexOf(clonedCard);
            const actionIndex = [...clonedCard.querySelectorAll('a,summary,button')].indexOf(action);
            const original = this.group.children[cardIndex].querySelectorAll('a,summary,button')[actionIndex];
            this.pause();
            this.rail.scrollLeft = ((this.rail.scrollLeft % this.period) + this.period) % this.period;
            original.focus({preventScroll:true});
            original.dispatchEvent(new MouseEvent('click', {bubbles:true,cancelable:true,view:window,ctrlKey:event.ctrlKey,metaKey:event.metaKey,shiftKey:event.shiftKey,altKey:event.altKey}));
          }, options);
          this.querySelector('[data-track]').append(this.clone);
          this.querySelector('[data-controls]').hidden = false;
        }
        this.refresh = () => {
          this.period = this.group.getBoundingClientRect().width + parseFloat(getComputedStyle(this.querySelector('[data-track]')).gap);
          this.toggle.hidden = this.dataset.autoplay !== 'true' || !this.desktop.matches || this.motion.matches || !this.clone;
          this.toggle.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
          this.toggle.setAttribute('aria-pressed', String(this.paused));
          this.position = this.rail.scrollLeft;
        };
        this.pause = () => { this.paused = true; this.refresh(); };
        this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.refresh(); }, options);
        const step = direction => {
          this.pause();
          const card = this.group.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.group).gap);
          this.rail.scrollBy({left:direction * (card.getBoundingClientRect().width + gap), behavior:this.motion.matches ? 'instant' : 'smooth'});
        };
        this.querySelector('[data-prev]').addEventListener('click', () => step(-1), options);
        this.querySelector('[data-next]').addEventListener('click', () => step(1), options);
        this.rail.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.hovered = true; }, options);
        this.rail.addEventListener('pointerleave', () => { this.hovered = false; this.position = this.rail.scrollLeft; }, options);
        this.rail.addEventListener('pointerdown', event => {
          this.pause();
          if (event.pointerType !== 'mouse' || event.target.closest('a,button')) return;
          this.drag = {id:event.pointerId, x:event.clientX, left:this.rail.scrollLeft};
          this.rail.setPointerCapture(event.pointerId);
          this.rail.style.cursor = 'grabbing';
          this.rail.style.userSelect = 'none';
        }, options);
        this.rail.addEventListener('pointermove', event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          this.rail.scrollLeft = this.drag.left + this.drag.x - event.clientX;
        }, options);
        const endDrag = () => { this.drag = null; this.rail.style.cursor = ''; this.rail.style.userSelect = ''; };
        this.rail.addEventListener('pointerup', endDrag, options);
        this.rail.addEventListener('pointercancel', endDrag, options);
        this.rail.addEventListener('wheel', this.pause, {...options, passive:true});
        this.rail.addEventListener('keydown', this.pause, options);
        this.rail.addEventListener('toggle', event => { if (event.target.open) this.pause(); }, {...options, capture:true});
        this.addEventListener('shopify:block:select', event => {
          this.pause();
          const card = event.target.closest('.hho-customers__card');
          if (card) this.rail.scrollLeft += card.getBoundingClientRect().left - this.rail.getBoundingClientRect().left - 24;
        }, options);
        this.motion.addEventListener('change', this.refresh, options);
        this.desktop.addEventListener('change', this.refresh, options);
        this.resize = new ResizeObserver(this.refresh);
        this.resize.observe(this.group);
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.position = this.rail.scrollLeft; });
        this.observer.observe(this);
        this.refresh();
        let last = 0;
        const tick = time => {
          const delta = Math.min(time - last, 40);
          last = time;
          if (!this.paused && !this.hovered && this.inView && !document.hidden && this.desktop.matches && !this.motion.matches && this.clone && !this.rail.contains(document.activeElement)) {
            this.position += delta / 1000 * Number(this.dataset.speed || 18);
            if (this.position >= this.period) this.position -= this.period;
            this.rail.scrollLeft = this.position;
          }
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.abort?.abort();
        this.resize?.disconnect();
        this.observer?.disconnect();
        this.clone?.remove();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hholove-shop-by-category"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 990px)');
    const arrangeHomeSections = () => {
      document.querySelectorAll('.hho-categories').forEach(category => {
        const seriesSection = category.closest('.shopify-section');
        const parent = seriesSection?.parentElement;
        if (!parent) return;
        const productSection = Array.from(parent.children).find(section =>
          section.classList.contains('shopify-section') && section.querySelector('hho-product-showcase')
        );
        if (!productSection) return;
        if (mobile.matches && productSection.nextElementSibling !== seriesSection) {
          productSection.after(seriesSection);
        } else if (!mobile.matches && productSection.previousElementSibling !== seriesSection) {
          productSection.before(seriesSection);
        }
        // The product's sticky scroll measurements depend on its new page position.
        productSection.querySelector('hho-product-showcase').tick?.();
      });
    };
    mobile.addEventListener('change', arrangeHomeSections);
    document.addEventListener('shopify:section:load', arrangeHomeSections);
    document.addEventListener('shopify:section:reorder', arrangeHomeSections);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', arrangeHomeSections, { once: true });
    } else {
      arrangeHomeSections();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hholove-veterinary-stories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    function mount(root) {
      if (instances.has(root)) return;
      const track = root.querySelector('[data-track]');
      const cards = Array.from(root.querySelectorAll('[data-card]'));
      const dialog = root.querySelector('[data-dialog]');
      if (!track || !cards.length || !dialog || typeof dialog.showModal !== 'function') return;
      const controller = new AbortController();
      const { signal } = controller;
      const strings = JSON.parse(root.querySelector('[data-veterinary-strings]').textContent);
      const media = root.querySelector('[data-media]');
      const status = root.querySelector('[data-status]');
      const dots = Array.from(root.querySelectorAll('[data-dot]'));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = 0;
      let returnFocus = null;
      let oldOverflow = '';
      let loadTimer = 0;
      let raf = 0;
      let playerController = null;
      const position = index => cards[index].offsetLeft - cards[0].offsetLeft;
      function sync() {
        raf = 0;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const left = Math.max(0, track.scrollLeft);
        let nearest = 0;
        let distance = Infinity;
        cards.forEach((card, index) => {
          const delta = Math.abs(Math.min(position(index), maxScroll) - left);
          if (delta < distance) { distance = delta; nearest = index; }
        });
        activeIndex = nearest;
        dots.forEach((dot, index) => {
          if (index === activeIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      function scrollTo(index) {
        const nextIndex = (index + cards.length) % cards.length;
        track.scrollTo({ left: Math.min(position(nextIndex), track.scrollWidth - track.clientWidth), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      }
      function step(direction) {
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 2) return;
        const atStart = track.scrollLeft <= 2;
        const atEnd = track.scrollLeft >= maxScroll - 2;
        if (direction > 0 && atEnd) scrollTo(0);
        else if (direction < 0 && atStart) scrollTo(cards.length - 1);
        else scrollTo(activeIndex + direction);
      }
      function setStatus(text) { status.textContent = text; status.hidden = !text; }
      function fail() { clearTimeout(loadTimer); setStatus(strings.videoError); }
      function stopPlayer() {
        clearTimeout(loadTimer);
        playerController?.abort();
        playerController = null;
        const video = media.querySelector('video');
        if (video) { video.pause(); video.removeAttribute('src'); video.querySelectorAll('source').forEach(source => source.removeAttribute('src')); video.load(); }
        media.replaceChildren();
        setStatus('');
      }
      function open(card, trigger) {
        stopPlayer();
        returnFocus = trigger;
        const info = card.querySelector('[data-story-info]').content.cloneNode(true);
        const author = info.querySelector('[data-author]');
        root.querySelector('[data-dialog-title]').textContent = author.textContent;
        root.querySelector('[data-close]').setAttribute('aria-label', author.dataset.closeLabel);
        author.remove();
        const storySummary = info.querySelector('[data-story-summary]');
        root.querySelector('[data-dialog-summary]').textContent = storySummary.textContent;
        storySummary.remove();
        const footer = root.querySelector('[data-dialog-footer]');
        footer.replaceChildren(info);
        footer.hidden = !footer.querySelector('a');
        media.append(card.querySelector('[data-player]').content.cloneNode(true));
        oldOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
        root.querySelector('[data-close]').focus();
        playerController = new AbortController();
        const playerSignal = playerController.signal;
        setStatus(strings.loading);
        const video = media.querySelector('video');
        const iframe = media.querySelector('iframe');
        if (video) {
          video.addEventListener('error', fail, { signal: playerSignal });
          video.querySelectorAll('source').forEach(source => source.addEventListener('error', fail, { signal: playerSignal }));
          video.addEventListener('loadeddata', () => { clearTimeout(loadTimer); setStatus(''); }, { once: true, signal: playerSignal });
          video.addEventListener('playing', () => { clearTimeout(loadTimer); setStatus(''); }, { signal: playerSignal });
          loadTimer = window.setTimeout(fail, 15000);
          video.preload = 'auto';
          video.load();
          video.play().catch(() => { if (video.error) fail(); });
        } else if (iframe) {
          iframe.addEventListener('load', () => { clearTimeout(loadTimer); setStatus(''); }, { once: true, signal: playerSignal });
          iframe.addEventListener('error', fail, { signal: playerSignal });
          loadTimer = window.setTimeout(fail, 15000);
          iframe.src = iframe.dataset.src;
        } else if (media.querySelector('img')) {
          setStatus('');
        } else fail();
      }
      root.addEventListener('click', event => {
        const trigger = event.target.closest('[data-open]');
        if (trigger) open(trigger.closest('[data-card]'), trigger);
        else if (event.target.closest('[data-previous]')) step(-1);
        else if (event.target.closest('[data-next]')) step(1);
        else if (event.target.closest('[data-dot]')) scrollTo(Number(event.target.closest('[data-dot]').dataset.dot));
        else if (event.target.closest('[data-close]')) dialog.close();
      }, { signal });
      track.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(sync); }, { passive: true, signal });
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); step(event.key === 'ArrowRight' ? 1 : -1); }
        else if (event.key === 'Home') { event.preventDefault(); scrollTo(0); }
        else if (event.key === 'End') { event.preventDefault(); scrollTo(cards.length - 1); }
      }, { signal });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, { signal });
      dialog.addEventListener('close', () => {
        stopPlayer();
        document.body.style.overflow = oldOverflow;
        if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
      }, { signal });
      const resize = new ResizeObserver(sync);
      resize.observe(track);
      root.addEventListener('shopify:block:select', event => {
        const index = cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
        if (index >= 0) scrollTo(index);
      }, { signal });
      root.classList.add('is-ready');
      sync();
      instances.set(root, () => {
        if (dialog.open) { dialog.close(); document.body.style.overflow = oldOverflow; }
        stopPlayer();
        controller.abort();
        resize.disconnect();
        cancelAnimationFrame(raf);
        root.classList.remove('is-ready');
        instances.delete(root);
      });
    }
    function mountWithin(scope) {
      if (scope.matches?.('[data-veterinary-stories]')) mount(scope);
      scope.querySelectorAll('[data-veterinary-stories]').forEach(mount);
    }
    mountWithin(document);
    document.addEventListener('shopify:section:load', event => mountWithin(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('[data-veterinary-stories]').forEach(root => instances.get(root)?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-show"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hho-product-showcase')) {
    customElements.define('hho-product-showcase', class extends HTMLElement {
      connectedCallback() {
        this.frame = 0;
        this.clickUntil = 0;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.items = Array.from(this.querySelectorAll('[data-block-id]'));
        this.images = Array.from(this.querySelectorAll('[data-image]'));
        this.triggers = Array.from(this.querySelectorAll('.hps__trigger'));
        this.runway = this.querySelector('.hps__runway');
        this.rail = this.querySelector('.hps__rail');
        if (!this.items.length) return;
        this.desktop = matchMedia('(min-width: 991px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = -1;
        this.classList.add('is-enhanced');
        this.tick = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
        };
        this.triggers.forEach((trigger, index) => trigger.addEventListener('click', () => {
          if (!this.desktop.matches) return;
          this.select(index);
          const top = this.runway.getBoundingClientRect().top + scrollY - this.header;
          const distance = this.runway.offsetHeight - this.querySelector('.hps__sticky').offsetHeight;
          // Land in the middle of a product's scroll interval; preserve native page scrolling.
          this.clickTarget = index;
          this.clickUntil = performance.now() + (this.reduced.matches ? 0 : 1100);
          scrollTo({ top: top + distance * (index + .5) / this.items.length, behavior: this.reduced.matches ? 'instant' : 'smooth' });
        }, { signal }));
        this.addEventListener('keydown', event => {
          const at = this.triggers.indexOf(event.target);
          if (at < 0 || !this.desktop.matches) return;
          let next;
          if (event.key === 'ArrowDown') next = (at + 1) % this.items.length;
          if (event.key === 'ArrowUp') next = (at - 1 + this.items.length) % this.items.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.items.length - 1;
          if (next === undefined) return;
          event.preventDefault(); this.triggers[next].focus({ preventScroll: true }); this.triggers[next].click();
        }, { signal });
        window.addEventListener('scroll', this.tick, { passive: true, signal });
        window.addEventListener('resize', this.tick, { passive: true, signal });
        const cancelClick = () => { this.clickUntil = 0; };
        window.addEventListener('wheel', cancelClick, { passive: true, signal });
        window.addEventListener('touchstart', cancelClick, { passive: true, signal });
        this.desktop.addEventListener('change', () => { this.index = -1; this.tick(); }, { signal });
        this.resizeObserver = new ResizeObserver(() => { this.measureLine(); this.tick(); });
        this.items.forEach(item => this.resizeObserver.observe(item));
        this.headerElement = document.getElementById('HeaderWrapper');
        if (this.headerElement) this.resizeObserver.observe(this.headerElement);
        this.addEventListener('shopify:block:select', event => {
          const index = this.items.findIndex(item => item.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          if (this.desktop.matches) this.triggers[index].click();
          else this.rail.scrollTo({ left: this.items[index].offsetLeft, behavior: 'instant' });
        }, { signal });
        this.sync();
      }
      sync() {
        if (!this.desktop.matches) {
          this.items.forEach((item, index) => {
            item.querySelector('.hps__details').inert = false;
            this.triggers[index].removeAttribute('aria-expanded');
            this.triggers[index].tabIndex = -1;
          });
          return;
        }
        const rect = this.headerElement?.getBoundingClientRect();
        const position = this.headerElement && getComputedStyle(this.headerElement).position;
        const header = rect && ['fixed', 'sticky'].includes(position) ? Math.max(0, rect.bottom) : 0;
        this.header = header + (parseFloat(getComputedStyle(this).getPropertyValue('--hps-offset')) || 0);
        this.style.setProperty('--hps-header', `${this.header}px`);
        const distance = this.runway.offsetHeight - this.querySelector('.hps__sticky').offsetHeight;
        const progress = distance > 0 ? (this.header - this.runway.getBoundingClientRect().top) / distance : 0;
        const index = Math.max(0, Math.min(this.items.length - 1, Math.floor(progress * this.items.length)));
        if (performance.now() < this.clickUntil && index !== this.clickTarget) return;
        this.select(index);
      }
      select(index) {
        if (this.index === index) return;
        this.index = index;
        this.items.forEach((item, i) => {
          item.classList.toggle('is-active', i === index);
          this.triggers[i].tabIndex = 0;
          this.triggers[i].setAttribute('aria-expanded', String(i === index));
          item.querySelector('.hps__details').inert = i !== index;
          this.images[i].classList.toggle('is-active', i === index);
          this.images[i].classList.toggle('is-before', i < index);
          this.images[i].classList.toggle('is-after', i > index);
        });
        this.measureLine();
      }
      measureLine() {
        const item = this.items?.[this.index];
        if (!item || !this.desktop.matches) return;
        this.style.setProperty('--hps-line-top', `${item.offsetTop}px`);
        this.style.setProperty('--hps-line-height', `${item.offsetHeight}px`);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
